module.exports = __webpack_public_path__ + "static/img/banner2.b77e39a3.png";